import React from 'react';

export const SectionHeader: React.FC<components.SectionHeaderProps> = ({
  title,
  subtitle,
  hasBigTitle,
  className,
}) => (
  <div className={className}>
    {hasBigTitle ? (
      <h3>{title}</h3>
    ) : (
      <h4>{title}</h4>
    )}
    {!!subtitle && <p>{subtitle}</p>}
  </div>
);
